import { useLocation } from "react-use"

export function useQueryParams() {
  const location = useLocation()

  const paramString = location.search
  const params = new URLSearchParams(paramString)

  const update = (func: ((params: URLSearchParams) => void) | Record<string, any>) => {
    const params = new URLSearchParams(paramString)
    if (typeof func === "function") {
      func(params)
    } else if (typeof func === "object" && func) {
      Object.entries(func).forEach(([key, value]) => {
        if (value) {
          params.set(key, value)
        } else {
          params.delete(key)
        }
      })
    }

    history.replaceState({}, "", `${location.pathname}?${params.toString()}`)
  }

  return [params, update] as const
}
